(function casaRequestAPiece(){
  'use strict';

  var BRANDS = ['Chanel','Hermès','Louis Vuitton','Christian Dior','Gucci','Fendi',
                'Prada','Bottega Veneta','Balenciaga','Saint Laurent','Céline',
                'Jacquemus','Goyard','Other / not sure'];

  var BUDGETS = ['Under $1,000','$1,000 – $2,500','$2,500 – $5,000','$5,000 – $10,000',
                 '$10,000 – $25,000','$25,000+','Prefer to discuss'];

  function esc(v){ return String(v == null ? '' : v)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* ---------------- modal ---------------- */
  function build(){
    if (document.getElementById('modal-bagrequest')) return;
    var bd = document.createElement('div');
    bd.className = 'modal-backdrop';
    bd.id = 'modal-bagrequest';
    bd.setAttribute('onclick', "if(event.target===this) closeModal('bagrequest')");
    bd.innerHTML =
      '<div class="modal info-modal" role="dialog" aria-modal="true" aria-labelledby="casa-req-title">' +
        '<button class="modal-close" aria-label="Close" onclick="closeModal(\'bagrequest\')">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="info-head">' +
          '<h2 id="casa-req-title">Request a Piece</h2>' +
          '<p>Tell us what you are looking for and a specialist will source it for you.</p>' +
        '</div>' +
        '<div class="info-body" id="casa-req-body"></div>' +
      '</div>';
    document.body.appendChild(bd);
    paintForm();
  }

  function paintForm(){
    var body = document.getElementById('casa-req-body');
    if (!body) return;
    var prefillEmail = (window.casaUser && window.casaUser.email) || '';
    var prefillName  = (window.casaUser && window.casaUser.name)  || '';

    body.innerHTML =
      '<form class="casa-req-form" id="casa-req-form" novalidate>' +
        '<div class="casa-req-row">' +
          '<div class="casa-req-field"><label for="creq-name">Your name</label>' +
            '<input id="creq-name" name="Name" type="text" autocomplete="name" required value="' + esc(prefillName) + '"></div>' +
          '<div class="casa-req-field"><label for="creq-email">Email</label>' +
            '<input id="creq-email" name="Email" type="email" autocomplete="email" required value="' + esc(prefillEmail) + '"></div>' +
        '</div>' +
        '<div class="casa-req-row">' +
          '<div class="casa-req-field"><label for="creq-phone">Phone <span style="text-transform:none;letter-spacing:0">(optional)</span></label>' +
            '<input id="creq-phone" name="Phone" type="tel" autocomplete="tel"></div>' +
          '<div class="casa-req-field"><label for="creq-brand">Brand</label>' +
            '<select id="creq-brand" name="Brand">' +
              BRANDS.map(function(b){ return '<option>' + esc(b) + '</option>'; }).join('') +
            '</select></div>' +
        '</div>' +
        '<div class="casa-req-field"><label for="creq-model">Model or style</label>' +
          '<input id="creq-model" name="Model" type="text" placeholder="Birkin 25, Classic Flap Medium, Capucines MM…"></div>' +
        '<div class="casa-req-row">' +
          '<div class="casa-req-field"><label for="creq-spec">Colour, size, hardware</label>' +
            '<input id="creq-spec" name="Colour / size / hardware" type="text" placeholder="Etoupe, gold hardware"></div>' +
          '<div class="casa-req-field"><label for="creq-budget">Budget</label>' +
            '<select id="creq-budget" name="Budget">' +
              BUDGETS.map(function(b){ return '<option>' + esc(b) + '</option>'; }).join('') +
            '</select></div>' +
        '</div>' +
        '<div class="casa-req-field"><label for="creq-notes">Anything else we should know</label>' +
          '<textarea id="creq-notes" name="Notes" placeholder="Condition you would accept, whether you need box and dust bag, when you need it by…"></textarea></div>' +
        '<p class="casa-req-note">We use these details only to source your piece and to reply to you. Requests are free and place you under no obligation to buy.</p>' +
        '<div class="casa-req-actions">' +
          '<span class="casa-req-err" role="alert"></span>' +
          '<button type="button" class="casa-req-btn" style="background:#fff;color:#141414" onclick="closeModal(\'bagrequest\')">Cancel</button>' +
          '<button type="submit" class="casa-req-btn">Send request</button>' +
        '</div>' +
      '</form>';

    var form = document.getElementById('casa-req-form');
    form.addEventListener('submit', submit);
  }

  function submit(ev){
    ev.preventDefault();
    var form = ev.target;
    var err  = form.querySelector('.casa-req-err');
    var btn  = form.querySelector('button[type=submit]');
    err.textContent = '';

    var name  = form.querySelector('#creq-name').value.trim();
    var email = form.querySelector('#creq-email').value.trim();
    var model = form.querySelector('#creq-model').value.trim();

    if (name.length < 2)  { err.textContent = 'Please tell us your name.'; form.querySelector('#creq-name').focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email so we can reply.'; form.querySelector('#creq-email').focus(); return; }
    // A request with no brand AND no model is not actionable — Casa would have to
    // email back just to ask what the person wants.
    var brand = form.querySelector('#creq-brand').value;
    if (!model && (!brand || /not sure/i.test(brand))) {
      err.textContent = 'Please name a brand or a model so we know what to look for.';
      form.querySelector('#creq-model').focus(); return;
    }

    var data = {};
    Array.prototype.forEach.call(form.querySelectorAll('input,select,textarea'), function(el){
      if (el.name && String(el.value || '').trim()) data[el.name] = el.value.trim();
    });
    data['Submitted from'] = (location.pathname + location.search) || '/';

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Sending…';

    var done = function(ok){
      btn.disabled = false; btn.textContent = original;
      if (!ok) { err.textContent = 'Something went wrong sending that. Please email info@casaconsignment.com and we will pick it up.'; return; }
      success(name);
    };

    try {
      var p = window.casaSubmitIntake('bag_request', data);
      if (p && typeof p.then === 'function') {
        p.then(function(r){
          // fetch() resolves on 4xx/5xx too, so check the status rather than
          // assuming a resolved promise means the request landed.
          done(!r || r.simulated || typeof r.ok === 'undefined' ? true : !!r.ok);
        }).catch(function(){ done(false); });
      } else { done(true); }
    } catch(e){ done(false); }
  }

  function success(name){
    var body = document.getElementById('casa-req-body');
    if (!body) return;
    body.innerHTML =
      '<div class="casa-req-success">' +
        '<div class="tick">✓</div>' +
        '<h3>Thank you' + (name ? ', ' + esc(name.split(' ')[0]) : '') + '.</h3>' +
        '<p>Your request is with a specialist. We will come back to you personally, usually within two business days — sooner if we already have something close. A confirmation is on its way to your inbox.</p>' +
      '</div>';
  }

  window.casaRequestPiece = function(){
    build();
    // Re-paint so a second request after a successful one gets a fresh form
    // rather than the previous confirmation screen.
    if (document.querySelector('.casa-req-success')) paintForm();
    if (typeof openModal === 'function') openModal('bagrequest');
  };

  /* ---------------- entry points ---------------- */
  function inject(){
    build();

    // 1) Portal nav — for the visitor who arrives already knowing what they want.
    var nav = document.querySelector('.portal-nav-top');
    if (nav && !nav.querySelector('.portal-link-req')) {
      var b = document.createElement('button');
      b.className = 'portal-link portal-link-req';
      b.type = 'button';
      b.textContent = 'Request a Piece';
      b.onclick = function(){ window.casaRequestPiece(); };
      nav.appendChild(b);
    }

    // 2) Below the Shop and Discover grids — caught at the exact moment someone
    //    has looked through everything and not found it.
    ['shop-grid','newin-grid'].forEach(function(id){
      var grid = document.getElementById(id);
      if (!grid || !grid.parentNode) return;
      if (grid.parentNode.querySelector('.casa-req-cta')) return;
      var cta = document.createElement('div');
      cta.className = 'casa-req-cta';
      cta.innerHTML =
        '<span class="eyebrow">Not Seeing It?</span>' +
        '<h3>Let us find it for you.</h3>' +
        '<p>Our specialists source privately, well beyond what is listed here. Tell us the piece you have in mind and we will go looking.</p>' +
        '<button type="button" class="casa-req-btn">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.2-4.2"/></svg>' +
          'Request a Piece' +
        '</button>';
      cta.querySelector('button').onclick = function(){ window.casaRequestPiece(); };
      grid.parentNode.insertBefore(cta, grid.nextSibling);
    });

    // 3) Support menu, next to Contact Us.
    document.querySelectorAll('.top-menu-panel').forEach(function(panel){
      var links = panel.querySelectorAll('a');
      for (var i = 0; i < links.length; i++) {
        if (/contact us/i.test(links[i].textContent || '')) {
          if (panel.querySelector('.casa-req-menu-link')) return;
          var a = document.createElement('a');
          a.className = 'casa-req-menu-link';
          a.href = '#';
          a.textContent = 'Request a Piece';
          a.style.cursor = 'pointer';
          a.onclick = function(e){ e.preventDefault(); window.casaRequestPiece(); };
          links[i].parentNode.insertBefore(a, links[i].nextSibling);
          return;
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
  // The grids and the top menu are built by script after load, so retry.
  setTimeout(inject, 900); setTimeout(inject, 2400);

  /* ---------------- deep links from the indexable /bag/ pages ---------------- */
  // Those pages are what Google and shared links land on. Their calls to action
  // point back here as /?sku=CASA-0021#shop and /?request=1 — without this the
  // visitor would arrive at the homepage and have to hunt for the piece they just
  // clicked, which is exactly the drop-off the pages exist to prevent.
  function handleDeepLink(){
    var q;
    try { q = new URLSearchParams(location.search); } catch(e){ return; }

    if (q.get('request')) {
      q.delete('request');
      history.replaceState({}, '', location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash);
      setTimeout(function(){ window.casaRequestPiece(); }, 350);
      return;
    }

    var sku = (q.get('sku') || '').toUpperCase();
    if (!sku) return;

    // Resolve the SKU to its index in `arrivals`, which is what openQuickView
    // takes. Poll briefly: the catalogue is assembled by a later script, so on a
    // cold load it may not exist yet.
    var tries = 0;
    (function attempt(){
      tries++;
      var list = null;
      try { list = (typeof arrivals !== 'undefined' && arrivals) || window.arrivals || null; } catch(e){ list = null; }
      if (list && list.length) {
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].sku || '').toUpperCase() === sku) {
            q.delete('sku');
            history.replaceState({}, '', location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash);
            if (typeof switchView === 'function') switchView('shop');
            setTimeout(function(){ if (typeof openQuickView === 'function') openQuickView(i); }, 260);
            return;
          }
        }
        // Catalogue is loaded and the SKU genuinely is not in it (sold and
        // removed). Land on the shop rather than doing nothing at all.
        if (typeof switchView === 'function') switchView('shop');
        return;
      }
      if (tries < 24) setTimeout(attempt, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleDeepLink);
  else handleDeepLink();

  console.log('  ✓ Deep links: /?sku=CASA-#### opens the piece, /?request=1 opens the request form');
  console.log('  ✓ Request a Piece — nav, shop/discover grids, support menu → /api/intake (bag_request)');
})();
